import PropTypes from "prop-types"
import ContributorsDetailsTable from "components/contributors-details-table"
import ContributorsOptions from "components/contributors-options"
import "./style.scss"

function ContributorsDetails({
  selected,
  data,
  selectedGroup,
  selectedGroupSiblings,
  selectedBasket,
  showGroup,
  hideGroup,
  openBasket,
  closeBasket,
  showBasketGroup,
  hideBasketGroup,
  setContributorsGrouping,
  contributorsGrouping,
  groupedData,
  openFactorProfile,
  openSecurityProfile,
  openCompositeSecurity,
  sort,
  order,
  availableRollups,
  contributorsSummaryText,
  csvData,
  refEquityOverride,
  enableBasketDrillDown,
  groupsDropdownColumns,
}) {
  return (
    <div className="contributors-details-wrapper">
      <ContributorsOptions
        contributorsSummaryText={contributorsSummaryText}
        availableRollups={availableRollups}
        setGrouping={setContributorsGrouping}
        currentGrouping={contributorsGrouping}
        selectedGroup={selectedGroup}
        csvData={csvData}
      />
      <ContributorsDetailsTable
        {...{
          selected,
          data,
          openSecurityProfile,
          openFactorProfile,
          openCompositeSecurity,
          openBasket,
          contributorsGrouping,
          selectedGroup,
          selectedGroupSiblings,
          groupsDropdownColumns,
          selectedBasket,
          showGroup: selectedBasket ? showBasketGroup : showGroup,
          hideGroup: selectedBasket ? hideBasketGroup : hideGroup,
          closeBasket,
          groupedData,
          sort,
          order,
          refEquityOverride,
          enableBasketDrillDown,
        }}
      />
    </div>
  )
}

ContributorsDetails.propTypes = {
  contributorsSummaryText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  availableRollups: PropTypes.array.isRequired,
  setContributorsGrouping: PropTypes.func.isRequired,
  contributorsGrouping: PropTypes.object,
  csvData: PropTypes.object.isRequired,
  selected: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  openCompositeSecurity: PropTypes.func.isRequired,
  openBasket: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  selectedGroupSiblings: PropTypes.array,
  selectedBasket: PropTypes.object,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  showBasketGroup: PropTypes.func.isRequired,
  hideBasketGroup: PropTypes.func.isRequired,
  closeBasket: PropTypes.func.isRequired,
  groupedData: PropTypes.array,
  sort: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  refEquityOverride: PropTypes.bool,
  enableBasketDrillDown: PropTypes.bool,
  groupsDropdownColumns: PropTypes.array,
}

export default ContributorsDetails
